import { faWarning } from '@fortawesome/pro-regular-svg-icons'
import { Alert, Text } from '@pinchenterprisesnpm/friday-ui'
import { AlertIcon } from 'ui/components/common/style'

interface IOTPolicyWarningProps {
  payRate: number
}

export const OTPolicyWarning = ({ payRate }: IOTPolicyWarningProps) => {
  return (
    <Alert
      type='warning'
      content={() => (
        <>
          <AlertIcon icon={faWarning} />
          <Text m={0}>
            Per state law, if an employee works over 8 hours in a 24-hour period at a pay rate of
            under ${payRate}/hr, they will be eligible for time and a half pay on any hours over
            eight.
          </Text>
        </>
      )}
    />
  )
}
